import { Text, makeStyles, tokens } from '@fluentui/react-components';
import { formatAmount } from '../utils/price';
import type { OrderQuote } from '../types/catering';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalM,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground3,
  },
  eyebrow: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase100,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  title: {
    fontSize: tokens.fontSizeBase300,
  },
  divider: {
    width: '100%',
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalS,
  },
  attendeeLabel: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase100,
  },
  total: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
  },
});

export type OrderSummaryCardProps = {
  headcount: number;
  quote: OrderQuote;
  title?: string;
  attendeeLabel?: string;
};

export function OrderSummaryCard({
  headcount,
  quote,
  title = 'Catering',
  attendeeLabel = 'Attendees (Lunch)',
}: OrderSummaryCardProps) {
  const styles = useStyles();

  return (
    <section className={styles.root} aria-label="Order summary">
      <Text className={styles.eyebrow}>Order Summary</Text>
      <Text className={styles.title} weight="semibold">
        {title}
      </Text>
      <div className={styles.divider} />
      <div className={styles.details}>
        <Text className={styles.attendeeLabel}>
          {headcount}x {attendeeLabel}
        </Text>
        <Text className={styles.total}>{formatAmount(quote.total)}</Text>
      </div>
    </section>
  );
}
